import styled from 'styled-components';
import { media } from 'settings/style';

export const NotificationPrompt = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  max-width: 360px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 16px;
  z-index: 1000;

  ${media.md`
    bottom: 80px;
    right: 10px;
  `}
`;

export const PromptHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const NotificationIcon = styled.span`
  font-size: 20px;
  margin-right: 8px;
`;

export const PromptTitle = styled.strong`
  // Inherits default styling
`;

export const PromptMessage = styled.div`
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 12px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const YesButton = styled.button`
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: #1d4ed8;
  }
`;

export const NoButton = styled.button`
  background: #f3f4f6;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: #e5e7eb;
  }
`;